import { useState } from 'react'
import Layout from '../../components/Layout'

import { Space } from 'antd'
import Tab1 from './Tab1/index'
import Tab2 from './Tab2/index'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Tab5 from './Tab5'
import Tab6 from './Tab6'

const Dashboard = () => {
	const [activeTab, setActiveTab] = useState('tab1')
	const { t } = useTranslation()
	const { getMe } = useSelector((state) => state.main)

	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return <Tab1 />
			case 'tab2':
				return <Tab2 />
			case 'tab3':
				return <Tab3 />
			case 'tab4':
				return <Tab4 />
			case 'tab5':
				return <Tab5 />
			case 'tab6':
				return <Tab6 />

			default:
				return null
		}
	}

	return (
		<Layout>
			<div className="m-5">
				<h1 className="text-2xl font-bold">{t('dashboard')}</h1>
				<Space style={{ marginBottom: 16, gap: 20 }} className="mt-10">
					<button
						className={`${
							activeTab === 'tab1'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold `}
						onClick={() => setActiveTab('tab1')}
					>
						{t('dashboard')}
					</button>
					{get(getMe, 'Department2.Name', '') !== 'DokonManager' && (
						<button
							className={`${
								activeTab === 'tab2'
									? 'text-blue-900 underline underline-offset-8'
									: ''
							} font-semibold `}
							onClick={() => setActiveTab('tab2')}
						>
							{t('reports')}
						</button>
					)}
					<button
						className={`${
							activeTab === 'tab3'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold `}
						onClick={() => setActiveTab('tab3')}
					>
						{t('monthlyReports')}
					</button>
					<button
						className={`${
							activeTab === 'tab4'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold `}
						onClick={() => setActiveTab('tab4')}
					>
						{t('invoiceReports')}
					</button>
					<button
						className={`${
							activeTab === 'tab5'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold `}
						onClick={() => setActiveTab('tab5')}
					>
						{t('paymentReports')}
					</button>
					<button
						className={`${
							activeTab === 'tab6'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold `}
						onClick={() => setActiveTab('tab6')}
					>
						{t('rassrochkaReports')}
					</button>
				</Space>
				<div className="mt-3">{renderContent()}</div>
			</div>
		</Layout>
	)
}

export default Dashboard
